import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as Type from "@interface/index";
import * as Model from "@models/index";
import * as Middleware from "@middlewares/index";
import HTMLReactParser, { DOMNode } from "html-react-parser";

interface PropsInterface extends Type.ComponentInterface {}

interface StateInterface {
  login: string;
}

class SignInPage extends React.Component<PropsInterface, StateInterface> {
  public constructor(props: PropsInterface) {
    super(props);
    this.state = {
      login: "",
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  public componentDidMount() {
    document.title = "Login" + " | " + process.env.SITE_NAME;
    this.props.Dispatch(Middleware.Ui.Footer.hide());
    // this.props.Dispatch(Middleware.Ui.Header.hide());
  }

  public componentWillUnmount() {
    this.props.Dispatch(Middleware.Ui.Footer.show());
    // this.props.Dispatch(Middleware.Ui.Header.show());
  }

  private onSubmitHandler(event: React.FormEvent<HTMLFormElement>): void {
    const query = document.location.search;

    event.preventDefault();
    this.props.Dispatch(
      Middleware.Auth.checkEmail(this.state, (data) => {
        if (data.exist === true) {
          this.props.history.push(`/auth/signin${query !== null ? query : ""}`);
        } else {
          this.props.history.push(`/auth/signup${query !== null ? query : ""}`);
        }
      })
    );
  }

  private onChangeHandler(event: React.ChangeEvent<HTMLInputElement>): void {
    this.setState({ [event.target.name]: event.target.value });
  }

  public render() {
    return (
      <>
        <div className="auth auth--login">
          <div className="auth__wrapper">
            <Link
              className="auth__close"
              to={
                this.props.Store.Auth.preurl_status === "redirected"
                  ? "/"
                  : this.props.Store.Auth.preurl
              }
            />
            <div className="auth__header">
              <h1>Регистрация</h1>
            </div>
            <div className="auth__body">
              <form onSubmit={this.onSubmitHandler}>
                <div className="auth__input">
                  <label className="visually-hidden" htmlFor="login">
                    Ваш email*
                  </label>
                  <input
                    // className="error"
                    className="input"
                    type="email"
                    name="login"
                    id="login"
                    value={this.state.login}
                    onChange={this.onChangeHandler}
                    placeholder="E-mail"
                    required={true}
                  />
                </div>
                <div className="auth__footer">
                  <button
                    className="btn btn--white-grey auth__btn"
                    // onClick={(e) => e.preventDefault(e)}
                    type="submit"
                  >
                    Ок
                  </button>

                  {/* <div className="auth__socials">
                    <div className="auth__socials-desc">Быстрый вход:</div>
                    <div className="auth__socials-icons">
                      <Link to="#">
                        <i className="icon-vk" />
                      </Link>
                      <Link to="#">
                        <i className="icon-facebook" />
                      </Link>
                    </div>
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  (Store: any) => {
    return { Store };
  },
  (Dispatch: (action: any) => void) => {
    return { Dispatch: (action: any) => Dispatch(action) };
  }
)(SignInPage);
